import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowLanguageRead = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "language":
        if (!permission.isOtherReadable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
